import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast, Toaster } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DemoCliente() {
  const { sessao } = useParams();
  const navigate = useNavigate();
  const [fase, setFase] = useState("video");
  const [nome, setNome] = useState("");
  const [zap, setZap] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [encerrada, setEncerrada] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    document.title = "MontaJá · Demonstração";
    axios.get(`${API}/demo/sessao/${sessao}/estado`)
      .then(r => { if (r.data.sessao?.status !== "ativa") setEncerrada(true); })
      .catch(() => setEncerrada(true));
  }, [sessao]);

  const escolher = async (produto) => {
    setEnviando(true);
    try {
      const r = await axios.post(`${API}/demo/sessao/${sessao}/participante`, { nome, whatsapp: zap, produto });
      navigate(`/oferta/${r.data.token}`);
    } catch (err) {
      if (err?.response?.status === 410) setEncerrada(true);
      else toast.error(err?.response?.data?.detail || "Erro ao iniciar");
    } finally { setEnviando(false); }
  };

  const entrar = (e) => {
    e.preventDefault();
    if (nome.trim().length < 2 || zap.replace(/\D/g, "").length < 10) { toast.error("Informe nome e WhatsApp válidos"); return; }
    setFase("produto");
  };

  if (encerrada) {
    return (
      <div className="min-h-screen bg-[#0B1020] text-white flex flex-col items-center justify-center gap-4 p-8 text-center">
        <div className="text-2xl font-extrabold">Esta demonstração foi encerrada.</div>
        <div className="text-white/60">Obrigado por conhecer o MontaJá.</div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#0B1020] text-white flex flex-col items-center justify-center p-6">
      <Toaster richColors />
      {fase === "video" ? (
        <div className="w-full max-w-sm text-center">
          <video ref={videoRef} src="/media/demo-abertura.mp4" className="rounded-2xl w-full" playsInline
            onEnded={() => setFase("form")} onError={() => setFase("form")} data-testid="demo-video" />
          <button onClick={() => { videoRef.current?.play().catch(() => setFase("form")); }}
            className="mt-4 px-5 py-2.5 rounded-xl bg-[#FF6700] font-bold text-sm" data-testid="demo-play">▶ Tocar apresentação</button>
          <button onClick={() => setFase("form")} className="mt-4 ml-2 px-4 py-2.5 rounded-xl border border-white/20 text-sm" data-testid="demo-pular">Pular</button>
        </div>
      ) : fase === "produto" ? (
        <div className="w-full max-w-sm space-y-3" data-testid="demo-produtos">
          <div className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-[#FF6700]">MontaJá · Demonstração</div>
          <h1 className="text-2xl font-extrabold">Qual produto você comprou?</h1>
          <p className="text-sm text-white/60">Toque no produto para ver a oferta de montagem.</p>
          {[{ cod: "GR6P", nome: "Guarda-roupa 6 Portas", det: "Bela Móveis · 3 volumes" },
            { cod: "RKPL", nome: "Rack com Painel", det: "Bela Móveis · 2 volumes" }].map(p => (
            <button key={p.cod} disabled={enviando} onClick={() => escolher(p.cod)}
              className="w-full text-left rounded-xl bg-[#142766]/60 border border-[#126BFF]/30 px-4 py-4 hover:border-[#FF6700] transition-colors disabled:opacity-60"
              data-testid={`demo-produto-${p.cod}`}>
              <div className="font-extrabold">{p.nome}</div>
              <div className="text-xs text-white/50">{p.det}</div>
              <div className="text-xs text-[#FF6700] font-bold mt-1">Ver oferta de montagem →</div>
            </button>
          ))}
        </div>
      ) : (
        <form onSubmit={entrar} className="w-full max-w-sm space-y-3" data-testid="demo-form">
          <div className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-[#FF6700]">MontaJá · Demonstração</div>
          <h1 className="text-2xl font-extrabold">Viva a experiência do cliente</h1>
          <p className="text-sm text-white/60">Informe seu nome e WhatsApp — você receberá as mensagens reais da jornada, identificadas como demonstração.</p>
          <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Seu nome" required
            className="w-full rounded-xl bg-[#142766]/60 border border-[#126BFF]/30 px-4 py-3 text-sm outline-none" data-testid="demo-nome" />
          <input value={zap} onChange={e => setZap(e.target.value)} placeholder="WhatsApp (DDD + número)" required
            className="w-full rounded-xl bg-[#142766]/60 border border-[#126BFF]/30 px-4 py-3 text-sm outline-none" data-testid="demo-whatsapp" />
          <button disabled={enviando} className="w-full rounded-xl bg-[#FF6700] py-3 font-extrabold" data-testid="demo-comecar">
            Escolher meu produto →
          </button>
        </form>
      )}
    </div>
  );
}
